import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ColumnType } from '@cure-components/table/table.interfaces';

@Component({
  selector: 'td[app-table-cell]',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './table-cell.component.html',
})
export class TableCellComponent {
  @Input({ required: true }) column!: ColumnType;
  @Input({ required: true }) element!: any;
}
